
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcHeading as ObcHeadingElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/heading/heading.js';
 
 
 

 
 export const ObcHeading = createComponent({
   react: React,
   tagName: 'obc-heading',
   elementClass: ObcHeadingElement,
   events: {
     
   }
  });
 
 